import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

export interface RejectionDialogData {
  key: string;
  value: string;
}

@Component({
  selector: 'app-rejection-dialog',
  templateUrl: './rejection-dialog.component.html',
  styleUrl: './rejection-dialog.component.scss',
})
export class RejectionDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() data: RejectionDialogData[] = [];
  @Input() isLoading: boolean = false;
  @Input() title: string = 'Details';
  @Input() readOnly: boolean = false;
  @Input() remarksValue: string = '';
  @Input() remarksRequired: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() rejected = new EventEmitter<string>();

  remarks: string = '';
  remarksTouched: boolean = false;
  readonly remarksMinLength = 3;
  readonly remarksMaxLength = 250;

  ngOnChanges(): void {
    if (this.remarksValue) {
      this.remarks = this.remarksValue;
    }
  }

  closeDialog(): void {
    this.remarks = '';
    this.remarksTouched = false;
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onRemarksChange(value: string): void {
    this.remarks = value || '';
  }

  onRemarksBlur(): void {
    this.remarksTouched = true;
  }

  getRemarksErrorMessage(): string {
    const trimmedRemarks = this.remarks.trim();

    if (!this.remarksRequired || this.readOnly) {
      return '';
    }

    if (!trimmedRemarks) {
      return '';
    }

    if (trimmedRemarks.length < this.remarksMinLength) {
      return `Remarks must be at least ${this.remarksMinLength} characters.`;
    }

    if (this.remarks.length > this.remarksMaxLength) {
      return `Remarks must not exceed ${this.remarksMaxLength} characters.`;
    }

    return '';
  }

  isRemarksValid(): boolean {
    const trimmedRemarks = this.remarks.trim();

    if (!this.remarksRequired || this.readOnly) {
      return true;
    }

    return (
      trimmedRemarks.length >= this.remarksMinLength &&
      this.remarks.length <= this.remarksMaxLength
    );
  }

  shouldShowRemarksError(): boolean {
    return this.remarksTouched && !!this.getRemarksErrorMessage();
  }

  isRejectDisabled(): boolean {
    return this.isLoading || !this.isRemarksValid();
  }

  onReject(): void {
    if (this.isRejectDisabled()) {
      return;
    }

    this.rejected.emit(this.remarks.trim());
  }
}
